import React from 'react'

const EmptyTeamCard = (type) => {
  return (
    <div>EmptyTeamCard</div>
  )
}

export default EmptyTeamCard